// https://github.com/vuelidate/vuelidate/tree/v0.7.7/src/validators

const required = (value) => {
    if (Array.isArray(value)) return !!value.length;

    if (value === undefined || value === null) {
        return false;
    }

    if (value === false) {
        return true;
    }

    if (value instanceof Date) {
        return !isNaN(value.getTime());
    }

    if (typeof value === 'object') {
        for (var _ in value) {
            return true;
        }

        return false;
    }

    return !!String(value.trim()).length;
}

const email = (value) => {
    const emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
    const regex = new RegExp(emailRegex);
    
    return regex.test(value);
}

const minLength = (length) => (value) => {
    let result = 0;

    if (Array.isArray(value)) result = value.length;

    if (typeof value === 'object') {
        result = Object.keys(value).length;
    }

    result = String(value).length;

    // !required(value) || len(value) >= length
    return !required(value) || result >= length;
}

const maxLength = (length) => (value) => {
    let result = 0;

    if (!value) return !required(value);

    if (Array.isArray(value)) result = value.length;

    if (typeof value === 'object') {
        result = Object.keys(value).length;
    }

    result = String(value).length;

    return !required(value) || result <= length;
}

const sameAs = () => (_, vm) => {
    return !required(vm.password) || vm.password == vm.passwordConfirmation;
}

export {
    required,
    email,
    minLength,
    maxLength,
    sameAs,
}
